// 0.5% VLSFO bunker prices by port, US$/tonne. Actuals: Alphaliner Monthly Monitor, Sep 2026 (p39-40).
// Forecast (singaporeF): Singapore VLSFO forward curve, trade date 17 Sep 2026. VLSFO is quoted per tonne
// (Alphaliner / ShipandBunker / BunkerIndex) — not per barrel.
export const bunkerMonthly = [
  { month: "Jan '26", rotterdam: 424, singapore: 448, houston: 444, singaporeF: null },
  { month: "Feb '26", rotterdam: 459, singapore: 485, houston: 479, singaporeF: null },
  { month: "Mar '26", rotterdam: 731, singapore: 929, houston: 783, singaporeF: null },
  { month: "Apr '26", rotterdam: 697, singapore: 780, houston: 868, singaporeF: null },
  { month: "May '26", rotterdam: 757, singapore: 824, houston: 841, singaporeF: null },
  { month: "Jun '26", rotterdam: 633, singapore: 735, houston: 712, singaporeF: null },
  { month: "Jul '26", rotterdam: 657, singapore: 755, houston: 678, singaporeF: null },
  { month: "Aug '26", rotterdam: 658, singapore: 816, houston: 685, singaporeF: null },
  { month: "Sep '26", rotterdam: 704, singapore: 850, houston: 739, singaporeF: 850 },
  { month: "Oct '26", rotterdam: null, singapore: null, houston: null, singaporeF: 840.86 },
  { month: "Nov '26", rotterdam: null, singapore: null, houston: null, singaporeF: 790.21 },
  { month: "Dec '26", rotterdam: null, singapore: null, houston: null, singaporeF: 752.34 },
  { month: "Jan '27", rotterdam: null, singapore: null, houston: null, singaporeF: 721.99 },
  { month: "Feb '27", rotterdam: null, singapore: null, houston: null, singaporeF: 697.08 },
  { month: "Mar '27", rotterdam: null, singapore: null, houston: null, singaporeF: 677.24 },
  { month: "Apr '27", rotterdam: null, singapore: null, houston: null, singaporeF: 660.20 },
  { month: "May '27", rotterdam: null, singapore: null, houston: null, singaporeF: 645.25 },
  { month: "Jun '27", rotterdam: null, singapore: null, houston: null, singaporeF: 632.21 },
  { month: "Jul '27", rotterdam: null, singapore: null, houston: null, singaporeF: 620.88 },
  { month: "Aug '27", rotterdam: null, singapore: null, houston: null, singaporeF: 611.10 },
  { month: "Sep '27", rotterdam: null, singapore: null, houston: null, singaporeF: 602.76 },
];

// Latest actual month snapshot (Sep 2026) with month-on-month and year-on-year change.
export const bunkerLatest = [
  { port: "Rotterdam", vlsfo: 704, lsmgo: 1384, ifo380: 589, mom: 7, yoy: 53, color: "#2a78d6" },
  { port: "Singapore", vlsfo: 850, lsmgo: 1281, ifo380: 672, mom: 4, yoy: 74, color: "#1baf7a" },
  { port: "Houston", vlsfo: 739, lsmgo: 1361, ifo380: 529, mom: 8, yoy: 50, color: "#eda100" },
];

export const bunkerSource = "Actuals: Alphaliner Monthly Monitor, Sep 2026 (0.5% VLSFO, US$/tonne). Forecast (dotted): Singapore VLSFO forward curve, trade date 17 Sep 2026. Rotterdam & Houston cross-checked vs ShipandBunker / BunkerIndex.";
